import React from 'react'
import { Link } from 'react-router'
import DesktopPreferencesFormContainer from '../../containers/settings/desktop-preferences-form-container'
import EmailPreferencesFormContainer from '../../containers/settings/email-preferences-form-container'
import MobilePreferencesFormContainer from '../../containers/settings/mobile-preferences-form-container'
import SubLocationNotificationFormContainer from '../../containers/settings/sub-location-notification-form-container'
import { Details, Row, Block } from '../../components/details/details'
import { ButtonRow, Button } from '../../components/buttons'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'


export default class Settings extends React.Component {
  render () {
    const { email, userName } = this.props

    return (
      <Details className='settings-list'>
        <Row>
          <div className="details-block">
            <h1>
              { email && userName &&
                `${userName} (${email})`
              }
            </h1>
          </div>
        </Row>
        <Row>
          <Block>
            <h1>My Reports</h1>
            <ButtonRow style={{display: 'flex', alignItems: 'center'}}>
              <span style={{flex: '4'}}>Historical Reports:</span>
              <Tooltip
                overlay={<span>Work Tracker historical reports</span>}
                placement='left'>
                <Button small to="/reports" style={{flexAlign: 'end'}}>View Reports</Button>
              </Tooltip>
            </ButtonRow>
          </Block>
        </Row>
        <Row>
          <Block>
            <DesktopPreferencesFormContainer />
          </Block>
        </Row>
        <Row>
          <Block>
            <MobilePreferencesFormContainer />
          </Block>
        </Row>
        <Row>
          <Block>
            <EmailPreferencesFormContainer />
          </Block>
        </Row>
        <Row>
          <Block>
            <SubLocationNotificationFormContainer />
          </Block>
        </Row>
      </Details>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/settings.js